import React from "react";
import "./MainInput.css";

const MainInput = ({
  value,
  onChange,
  placeholder,
  type = "text",
  autoComplete,
  name,
  disabled,
  required,
  rows,
}) => {
  if (type === "textarea") {
    return (
      <textarea
        className="main-input"
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        disabled={disabled}
        required={required}
        rows={rows || 2}
      />
    );
  }

  return (
    <input
      className="main-input"
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      autoComplete={autoComplete}
      disabled={disabled}
      required={required}
    />
  );
};

export default MainInput;
